export function useDrawer({ component } = {}) {
  const defaultState = { open: false, edit: false, view: false, props: {} };

  const state = ref({ ...defaultState });

  const { toggleRightDrawer, toggleNestedRightDrawer } = useAppStore();

  const toggle = (newState = {}) => {
    const incoming = unref(newState);
    const currentState = unref(state);
    const isNested =
      Object.hasOwn(incoming, "level") || Object.hasOwn(currentState, "level");
    const level = incoming.level ?? currentState.level;

    const nextOpen = Object.hasOwn(incoming, "open")
      ? incoming.open
      : !state.value.open;

    state.value = nextOpen
      ? { ...currentState, open: true, ...incoming }
      : { ...defaultState };

    if (isNested) {
      toggleNestedRightDrawer({ component, ...unref(state), level });
    } else {
      toggleRightDrawer(unref(state).open, component, unref(state).props);
    }
  };

  return {
    state,
    toggle,
  };
}
